var render, staticRenderFns
import script from "./damage.vue?vue&type=script&lang=js&"
export * from "./damage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d484db16",
  null
  
)

export default component.exports